import myImage from "./../assets/img/me.jpg"
import logoImage from "./../assets/img/logo-pnh - Copy.png"
import backendIcon from "./../assets/img/frontend.svg"
import designIcon from "./../assets/img/designer.svg"

import img1 from "./../assets/img/mockups/1.png"
import img2 from "./../assets/img/mockups/2.png"
import img3 from "./../assets/img/mockups/3.png"
import img4 from "./../assets/img/mockups/4.png"
import img5 from "./../assets/img/mockups/5.png"
import img6 from "./../assets/img/mockups/6.png"
import img7 from "./../assets/img/mockups/7.png"
import img8 from "./../assets/img/mockups/8.png"
import img9 from "./../assets/img/mockups/9.png"
import img10 from "./../assets/img/mockups/10.png"
import img11 from "./../assets/img/mockups/11.png"
import img12 from "./../assets/img/mockups/12.png"
import img13 from "./../assets/img/mockups/13.png"
import img14 from "./../assets/img/mockups/14.png"
import img15 from "./../assets/img/mockups/15.png"
import img16 from "./../assets/img/mockups/16.png"
import img17 from "./../assets/img/mockups/17.png"
import img18 from "./../assets/img/mockups/18.png"
const projectImages = [
	{
		id: 1,
		images: [img5],
	},
	{
		id: 2,
		images: [img2, img3],
	},
	{
		id: 3,
		images: [img1, img11],
	},
	{
		id: 4,
		images: [img4],
	},
	{
		id: 5,
		images: [img16, img17, img18],
	},
	{
		id: 6,
		images: [img14, img13, img9, img15, img6],
	},
	{
		id: 7,
		images: [img8, img10, img4],
	},
	{
		id: 8,
		images: [img12, img7],
	},
]

export { myImage, logoImage, backendIcon, designIcon, projectImages }
